module.exports = __webpack_public_path__ + "assets/img/34_710.96e920bc.jpg";